var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5317_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8536 3.1464C14.7598 3.05266 14.6327 3 14.5001 3C14.3675 3 14.2404 3.05266 14.1466 3.1464L9 8.29299L3.85341 3.1464C3.75964 3.05266 3.63249 3 3.4999 3C3.36732 3 3.24016 3.05266 3.1464 3.1464C3.05266 3.24016 3 3.36732 3 3.4999C3 3.63249 3.05266 3.75964 3.1464 3.85341L8.29299 9L3.1464 14.1466C3.05266 14.2404 3 14.3675 3 14.5001C3 14.6327 3.05266 14.7598 3.1464 14.8536C3.24016 14.9473 3.36732 15 3.4999 15C3.63249 15 3.75964 14.9473 3.85341 14.8536L9 9.70701L14.1466 14.8536C14.2404 14.9473 14.3675 15 14.5001 15C14.6327 15 14.7598 14.9473 14.8536 14.8536C14.9473 14.7598 15 14.6327 15 14.5001C15 14.3675 14.9473 14.2404 14.8536 14.1466L9.70701 9L14.8536 3.85341C14.9473 3.75964 15 3.63249 15 3.4999C15 3.36732 14.9473 3.24016 14.8536 3.1464Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5317_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b68e28099cacad9511e171124496dbc7.svg";
export { ForwardRef as ReactComponent };